import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserData } from "src/context/userContext";

export default function FrontPageRedirector() {
  const { auth, isLoggedIn } = useUserData();

  const navigate = useNavigate();
  const defaultUrl = localStorage.getItem("defaultUrl");
  useEffect(() => {
    if (!defaultUrl) {
      if (isLoggedIn && (auth.is?.pumppari || auth.is?.assignee)) {
        navigate("/tyot");
      } else navigate("/koti");
    } else {
      navigate(defaultUrl);
    }
  }, []);

  return null;
}
